import { NextRouter } from 'next/router';

export default async function refreshData(router: NextRouter): Promise<boolean> {
  return router.replace(router.asPath);
}
